import { AB_TESTS_DATA } from "@trueskin-web/ab-experiments"
import { ExpansionPanel, Heading } from "@trueskin-web/components"

const items = [
  [
    "Worin besteht die Mission von FORMEL SKIN?",
    <>
      <p>
        FORMEL SKIN ist ein dermatologisches Telemedizin-Unternehmen mit Sitz
        und Gründung in Berlin.
      </p>
      <p>
        Wir bei FORMEL SKIN setzen unseren Fokus gezielt auf eine fachkundige,
        medizinische Beratung, welche ausschließlich online stattfindet - daher
        auch der Begriff &apos;Telemedizin&apos;.
      </p>
      <p>
        Unser tägliches Anliegen ist es, Menschen mit Hautproblemen bis hin zu
        starker Akne und Neurodermitis, weiterzuhelfen. An einem Ausbau unserer
        speziellen Produkte zur Behandlung von Akne weiterer Körperstellen
        arbeiten wir bereits!
      </p>
    </>,
  ],
  [
    "Wie kann FORMEL SKIN mich behandeln?",
    <>
      <p>
        FORMEL SKIN behandelt nahezu alle dermatologischen Befunde online als
        telemedizinische private Dermatologie. Dabei behandeln wir einmal mit
        Produkten (inkl. einer personalisierten Formel) und auch als
        Diagnoseservice mit Privatrezept.
      </p>
      <p>
        Die <strong>Behandlung mit Produkten</strong> ist vorwiegend für
        chronische Hautkrankheiten wie Akne, Rosazea, Melasma, Slow-aging u.Ä.
        im Gesicht geeignet. Du erhältst einen Behandlungsplan inklusive eines
        Produktsets, bestehend aus Reinigung, Formel und Pflege nach Hause
        gesendet. Die Formel wird mit Hilfe von monatlichen Check-ins an die
        Veränderung Deiner Haut angepasst. Du hast hier im Behandlungszeitraum
        immer die Möglichkeit mit dem behandelnden Arzt/ der behandelnden Ärztin
        in Kontakt zu treten.
      </p>
      <p>
        Der <strong>Diagnose-Service</strong> kann für dermatologische Befunde
        des ganzen Körpers verwendet werden. Auch hier erhältst Du zur Diagnose
        einen Behandlungsplan und nach Bedarf ein Privatrezept nach Hause
        gesendet.{" "}
        <a
          href="https://formelskinapp.zendesk.com/hc/de"
          target="_blank"
          rel="noreferrer"
        >
          Hier
        </a>{" "}
        kannst Du mehr über die App erfahren.
      </p>
    </>,
  ],
  [
    "Wie wird meine Formel personalisiert?",
    <>
      <p>
        Die Formel wird für Dich persönlich hergestellt und enthält
        Inhaltsstoffe, die auf Deine Haut abgestimmt sind. Nach der Diagnose
        durch Deine Ärztin/Deinen Arzt, wird die individuelle Rezeptur in der
        Apotheke für Dich angemischt.{" "}
      </p>
      <p>
        Unsere Wirkstoffe sind klinisch geprüft und werden seit Jahrzehnten
        erfolgreich von Dermatolog*innen eingesetzt. In allen Produkten
        verzichten wir auf Duft- und Parfümstoffe, unnötige Pflanzenextrakte,
        Farbstoffe und Allergie-auslösende Konservierungsstoffe. Erfahre{" "}
        <a
          href="https://www.formelskin.de/unsere-produkte"
          target="_blank"
          rel="noreferrer"
        >
          hier
        </a>{" "}
        mehr darüber, welche Inhaltsstoffe wir nutzen und was sie bewirken. Die
        Inhaltsstoffe Deiner Formel kannst Du dann in Deinem Behandlungsplan
        (nach Vervollständigen des Anamnesebogens) nachlesen.
      </p>
      <p>
        Mehr über die Wirkstoffe findest Du{" "}
        <a
          href="https://support.formelskin.de/hc/de/categories/360002991279-Wirkstoffe-Nebenwirkungsmanagement"
          target="_blank"
          rel="noreferrer"
        >
          hier.
        </a>
      </p>
      <p>
        Deine Formel solltest Du, wenn nicht anders mit Deiner Ärztin/Deinem
        Arzt vereinbart, jeden Abend auftragen (bei Nebenwirkungen kann das
        Intervall auf 2-3 Tage verlängert werden). Die genaue Anwendung kannst
        Du jederzeit{" "}
        <a
          href="https://www.formelskin.de/app/deine-routine"
          target="_blank"
          rel="noreferrer"
        >
          im Login
        </a>{" "}
        oder der mitgelieferten Broschüre entnehmen.
      </p>
    </>,
  ],
  [
    "Ich bin privat krankenversichert. Wie funktioniert es?",
    <>
      <p>
        <a
          href="https://support.formelskin.de/hc/de/requests/new"
          target="_blank"
          rel="noreferrer"
        >
          Schreib uns gern
        </a>
        , wenn Du Dein Rezept für Deine Krankenversicherung benötigst, um Kosten
        anteilig zurückerstattet zu bekommen. Wir lassen es Dir dann ohne
        zusätzliche Kosten abgestempelt zukommen - egal ob Du einen Einmalkauf
        getätigt oder das Auto-Refill gewählt hast.
      </p>
      <p>
        <strong sx={{ textDecoration: "underline" }}>
          Welche Kosten werden übernommen?
        </strong>
      </p>
      <ul>
        <li>
          Die Kosten für die medizinische Formel und die ärztliche Leistung
          werden von einigen privaten Krankenkassen übernommen; in Zukunft
          hoffentlich auch von den gesetzlichen Krankenkassen.
        </li>
      </ul>
      <p>
        Frage hier vorab am besten einmal bei Deiner Krankenversicherung nach,
        ob sie anteilig Kosten übernimmt.{" "}
      </p>
      <p>
        <strong sx={{ textDecoration: "underline" }}>Was benötigst Du?</strong>
      </p>
      <ul>
        <li>
          Die Rechnung und das Rezept reichen meistens schon aus. Du bekommst
          die Rechnung immer direkt nach Erstellung Deines Behandlungsplans per
          Mail zugeschickt. Zudem kannst Du sie{" "}
          <a
            href="https://www.formelskin.de/app/dein-konto/meine-lieferungen"
            target="_blank"
            rel="noreferrer"
          >
            hier im Login
          </a>{" "}
          jederzeit abrufen.
        </li>
      </ul>
      <p>
        Bitte melde Dich bei uns, wenn Du weitere Unterlagen zur Einreichung
        benötigst. Wir helfen gern dabei.
      </p>
    </>,
  ],
  [
    "Muss ich ein Abo bei euch abschließen?",
    <>
      <p>
        Nein. Du kannst Dich immer zwischen dem Auto-Refill und Einmalkauf
        entscheiden.
      </p>
      <p>
        <strong sx={{ textDecoration: "underline" }}>Auto-Refill:</strong>{" "}
        <br />
        Du hast{" "}
        <span sx={{ textDecoration: "underline" }}>
          keine Mindestlaufzeit
        </span>{" "}
        und dadurch bist Du auch an keine Vertragslaufzeit gebunden. Das
        Auto-Refill kannst Du zudem jederzeit in Deinem Login{" "}
        <a
          href="https://support.formelskin.de/hc/de/articles/360016023540-Wie-und-wann-kann-ich-mein-Auto-Refill-k%C3%BCndigen-"
          target="_blank"
          rel="noreferrer"
        >
          kündigen.
        </a>{" "}
      </p>
      <p data-vwo-hide={AB_TESTS_DATA.antiAging?.lsKey}>
        <strong sx={{ textDecoration: "underline" }}>Einmalkauf:</strong> <br />
        Hier bedarf es keiner extra Kündigung - die Behandlung läuft einfach
        nach dem Monat automatisch aus.
      </p>
    </>,
  ],
  [
    "Wann kann ich eine Diagnose erwarten?",
    <p key={0}>
      Unser medizinisches Team wird Deinen Fall innerhalb von 24-72 Stunden
      prüfen
    </p>,
  ],
]

const FAQ = () => {
  return (
    <>
      <Heading size="xsm" sx={{ mt: 6, mb: "28px", fontWeight: "bold" }}>
        Deine Fragen beantwortet
      </Heading>

      {items.map(([question, answer], index) => (
        <ExpansionPanel
          key={index}
          title={question}
          sx={{
            borderColor: "#E1E1E1",
            "& h3": {
              fontSize: 1,
            },
            "& h3 + div": {
              width: "24px",
              height: "24px",
            },
          }}
        >
          <div
            sx={{
              fontSize: 1,
              "& > p:first-of-type": {
                mt: 0,
              },
              "& a": {
                color: "inherit",
                "&:hover, &:focus": {
                  color: "primary",
                },
              },
            }}
          >
            {answer}
          </div>
        </ExpansionPanel>
      ))}
    </>
  )
}

export default FAQ
